export const myNewsTranslationsEn = {
  MY_NEWS_CONTENT_IS_REQUIRED: "Content is required!",
  MY_NEWS_DESCRIPTION_IS_REQUIRED: "Description is required!",
  MY_NEWS_TITLE_IS_REQUIRED: "Title is required!",
  MY_NEWS_END_DATE: "End date",
  MY_NEWS_START_DATE: "Start date",
  MY_NEWS_NEWS: "News",
  MY_NEWS_ADMIN_GUIDE: "MyNews administrator manual",
  MY_NEWS_EDITOR_GUIDE: "MyNews editor manual",
  MY_NEWS_USER_GUIDE: "MyNews user manual",
  MY_NEWS_DATE_CANNOT_BE_EARLIER: "This date cannot be earlier than today!",
  MY_NEWS_NO_NEWS: "No news at the moment!",
  MY_NEWS_EMBED_VIDEO: "Embed URL",
  MY_NEWS_HUGE: "Huge",
  MY_NEWS_LARGE: "Large",
  MY_NEWS_MEDIUM: "Medium",
  MY_NEWS_SMALL: "Small",
  MY_NEWS_EDIT_MY_NEWS_ITEM: "Edit news",
  MY_NEWS_READ_AGAIN: "Read again",
  MY_NEWS_DELETE_CONFIRM_INFO: "Are you really deleting the news?",
  MY_NEWS_MENU_ALLOWED_INFO: "By activating MyNews, the MyNews home screen and functions become available to all employees upon logging into the system.",
  MY_NEWS_EDITED: "Edited",
  MY_NEWS_ARCHIVED_NEWS: "Archived news!",
  MY_NEWS_UNPUBLISHED_NEWS: "Unpublished news!",
  MY_NEWS_READ: "Read",
  MY_NEWS_EDITING: "Edit",
  MY_NEWS_IMPORTANT: "Important",
  MY_NEWS_OWN_NEWS: "My news",
  MY_NEWS_ARCHIVED: "Archived",
  MY_NEWS_ACTUAL: "Actual news",
  MY_NEWS_SAVE_AND_PUBLISH: "Save and publish",
  MY_NEWS_DESCRIPTION: "Description",
  MY_NEWS_TITLE: "Title",
  MY_NEWS_NEW_ITEM: "New news",
};
